<div class="dialog-container">
    <div class="icon">
        <fa-icon *ngIf="data.icon" [icon]="icon" [ngClass]="colorClass"></fa-icon>
    </div>
    <div class="dialog-header">
        <h2>{{ data.title }}</h2>
    </div>
    <p *ngIf="data.subtitle" class="dialog-subtitle">{{ data.subtitle }}</p>

    <div class="dialog-footer">
        <button *ngFor="let btn of data.buttons" [ngClass]="btn.type || 'primary'" (click)="btn.action()">
            {{ btn.label }}
        </button>
    </div>
</div>